import React from 'react';

import { Box, Typography } from '@mui/material';

import { FONT_FAMILY, PRIMARY_GREEN } from './colors';

import type { PublicJob } from './types';

interface JobCardProps {
  job: PublicJob;
}

const JobCard = ({ job }: JobCardProps) => (
  <Box
    component="a"
    href={job.url}
    sx={{
      display: 'block',
      textDecoration: 'none',
      backgroundColor: '#FFFFFF',
      borderRadius: '12px',
      padding: '24px 24px 24px 32px',
      '&:hover': { backgroundColor: '#F7F7F7' }
    }}
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', maxWidth: '296px' }}>
      <Box
        sx={{
          alignSelf: 'flex-start',
          border: `1px solid ${PRIMARY_GREEN}`,
          borderRadius: '10px',
          padding: '10px 16px'
        }}
      >
        <Typography
          sx={{
            fontFamily: FONT_FAMILY,
            fontWeight: 600,
            fontSize: '12px',
            lineHeight: 1.2,
            color: '#03211F',
            textTransform: 'uppercase'
          }}
        >
          {job.reference}
        </Typography>
      </Box>
      <Typography
        sx={{
          fontFamily: FONT_FAMILY,
          fontWeight: 800,
          fontSize: '20px',
          lineHeight: 1.1,
          color: PRIMARY_GREEN
        }}
      >
        {job.title}
      </Typography>
      <Typography
        sx={{ fontFamily: FONT_FAMILY, fontWeight: 600, fontSize: '16px', color: PRIMARY_GREEN }}
      >
        {job.location}
      </Typography>
    </Box>
  </Box>
);

export default JobCard;
